import { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from "utils/useMediaQuery";

const MeetMe: React.FC = () => {
    const isMobile = useMediaQuery("(max-width: 800px)");

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        // centerMode: true,
        autoplaySpeed: 7000,
        cssEase: "linear"
    };

    return (
        <>
            <section>
                <group data-background="white" data-position="absolute" data-top="0" data-left="0" data-height="fit"></group>
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="desktop">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="500">
                                        <img src="./images/S6.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S6.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no">
                                    <space data-length="100" data-adaptive="desktop"></space>
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">“Who is Dr. Lernik”</text>
                                        </text>

                                        <text className="description" data-wrap="wrap" data-line="2">
                                            Dr. Lernik Essayei provides a comprehensive and evidence-based approach to health, grounded in a rare convergence of high-level credentials. With a medical degree (MD) from the internationally recognized Yerevan State Medical University (YSMU) and a year of  General Surgery training at Oregon Health Science University (OHSU), her clinical foundation is unmatched. She further distinguishes herself with a Master's in Health Policy and Management from New York University (NYU). Crucially, as a certified Lifestyle Medicine Practitioner, she bridges the gap between clinical science and daily life to achieve practical and sustainable vitality.
                                        </text>

                                    </group>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>




            <section>
                <group data-type="group">
                    <group data-background="grey-color" data-position="absolute" data-top="0" data-left="0"></group>
                    <group data-direction="column" data-height="300" data-justify="center">
                        <space data-length="120" data-adaptive="desktop"></space>
                        <space data-length="90" data-adaptive="mobile"></space>
                        <group data-wrap="no">
                            <space data-length="50" data-adaptive="desktop"></space>
                            <space data-length="30" data-adaptive="mobile"></space>
                            <group data-gap="10" data-justify="center" data-direction="column" data-align="center" >
                                <group data-wrap="no" data-radius="10" data-justify="center" data-gap="20" data-max-length="600" data-length="forcefit">
                                    <group data-opacity="30" data-width="auto" data-align="start"> <text data-type="group" data-text-size="64" data-line-height="50" data-height="20">“</text></group>
                                    <group data-direction="column" data-gap="10">
                                        <text className="list_description" data-wrap="wrap" data-text-size="14" data-line="2" data-text-align="justify" data-color="black"> When we bridge the gap between clinical science and people's real lives, staying healthy no longer feels like a chore.</text>
                                    </group>
                                    <group data-opacity="30" data-width="auto" data-align="end"><text data-rotate="180" data-type="group" data-text-size="64" data-line-height="50" data-height="20">“</text></group>
                                </group>
                            </group>
                            <space data-length="50" data-adaptive="desktop"></space>
                            <space data-length="30" data-adaptive="mobile"></space>
                        </group>
                        <space data-length="120" data-adaptive="desktop"></space>
                        <space data-length="90" data-adaptive="mobile"></space>
                    </group>
                </group>
            </section>

            <section>
                <group data-background="white" data-position="absolute" data-top="0" data-left="0" data-height="fit"></group>
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S7.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no" data-justify="end">
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">My journey</text>
                                        </text>
                                        <group data-gap="30">
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                My passion for health started before sunrise-literally. At just 11 years
                                                old, I was outside exercising at 6 a.m. driven by a love for movement
                                                and well-being that never left me. In my 20s, friends jokingly called me
                                                “grandma” because I valued early nights, restorative sleep and
                                                nourishing meals.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                Armed with a medical degree, I went on to serve in world-class
                                                institutions like Memorial Sloan-Kettering Cancer Center and Northwell
                                                Health, where I supported individuals and communities in their health
                                                journeys. Over the years, I learned that true health is more than
                                                medicine–it's about the way we live each day.


                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                The birth of my daughter deepened my commitment to building meaningful
                                                connections and supporting others in finding balance in a fast-paced
                                                world. That commitment led me to Lifestyle Medicine–a science-backed
                                                approach that uses everyday habits as powerful tools for healing and
                                                prevention.

                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                Today, through Aghvida, I help people create sustainable life-enhancing
                                                changes rooted in nutrition, movement, sleep, stress management, toxin
                                                avoidance, and positive connections–because your lifestyle is your
                                                strongest medicine.
                                            </text>

                                        </group>
                                    </group>
                                    <space data-length="100" data-adaptive="desktop"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="desktop"
                                    data-max-length="500">
                                    <picture data-object-fit="contain" data-ratio="1:1">
                                        <img src="./images/S7.png" alt="" />
                                    </picture>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>


            <section>
                <group data-background="main" data-position="absolute" data-top="0" data-left="0" data-height="fit"
                    data-opacity="10"></group>
                <group data-type="group">
                    <group data-background="secondary" data-position="absolute" data-top="0" data-left="0"
                        data-height="fit"></group>
                    <picture data-position="absolute" data-top="0" data-left="0">
                        <img src="./images/S8.png" alt="" data-opacity="40" />
                    </picture>

                    <group data-direction="column">
                        <space data-height="90"></space>
                        <group data-wrap="no">
                            <space data-length="50" data-adaptive="desktop"></space>
                            <space data-length="30" data-adaptive="mobile"></space>
                            <group data-gap="10" data-justify="center" data-direction="column" data-align="center"
                                data-color="white">
                                <text className="title" data-wrap="wrap" data-weight="700">
                                    <text data-wrap="wrap" data-text-size="xxx-large">Testimonials</text>
                                </text>

                                <text className="description" data-wrap="wrap" data-line="2">‘Hear from Those We Have
                                    helped’</text>

                            </group>
                            <space data-length="50" data-adaptive="desktop"></space>
                            <space data-length="30" data-adaptive="mobile"></space>
                        </group>
                        <space data-height="90"></space>
                    </group>
                </group>
                <group>
                    <space data-height="90" data-adaptive="desktop"></space>
                    <space data-height="40" data-adaptive="mobile"></space>
                    <group data-background="secondary" data-position="absolute" data-top="0" data-left="0"
                        data-height="fit" data-opacity="20"></group>
                    <group data-wrap="no" data-direction="column" data-gap="20" data-align="center" data-contain="">
                        <view data-background="none" data-space="20" data-space-bottom="50" data-border="no" >
                            <Slider {...settings}>
                                <div data-space-horizontal="10">
                                    <group className="" data-wrap="no" data-space="20" data-space-vertical="40"
                                        data-radius="10" data-backdrop="" data-justify="center"
                                        data-gap="20">
                                        <group data-opacity="30" data-width="auto" data-align="start"> <text
                                            data-type="group" data-text-size="64" data-line-height="50"
                                            data-height="20">“</text></group>
                                        <group data-direction="column" data-gap="10">
                                            <text data-wrap="wrap" data-text-size="16" data-color="black"
                                                data-weight="700">Morgan
                                                Black</text>
                                            <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                data-line="2" data-text-align="justify">
                                                “During the early days of COVID, Lernik shared helpful tips about
                                                stress management, sleep, and the benefits of being involved with
                                                your community, which were helpful to me.”
                                            </text>
                                        </group>
                                        <group data-opacity="30" data-width="auto" data-align="end"> <text
                                            data-rotate="180" data-type="group" data-text-size="64"
                                            data-line-height="50" data-height="20">“</text></group>
                                    </group>
                                </div>
                                <div data-space-horizontal="10">
                                    <group className="" data-wrap="no" data-space="20" data-space-vertical="40"
                                        data-radius="10" data-backdrop="" data-justify="center"
                                        data-gap="20">
                                        <group data-opacity="30" data-width="auto" data-align="start">
                                            <text data-type="group" data-text-size="64" data-line-height="50"
                                                data-height="20">“</text>
                                        </group>
                                        <group data-direction="column" data-gap="10">
                                            <text data-wrap="wrap" data-text-size="16" data-color="black"
                                                data-weight="700">Laura
                                                Maxwell</text>
                                            <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                data-line="2" data-text-align="justify">
                                                “Dr. Essayei is a physician dedicated to her patients’ overall
                                                health. During our interactions, I have learned ways to incorporate
                                                healthier living into my and my family’s lives. Her recommendations
                                                around consuming whole food nutrition have been particularly
                                                impactful. Her advice on dietary changes, tailored to my daughter’s
                                                preferences in flavor, has been a game-changer. I am incredibly
                                                grateful for her invaluable nutrition advice.”
                                            </text>
                                        </group>
                                        <group data-opacity="30" data-width="auto" data-align="end"> <text
                                            data-rotate="180" data-type="group" data-text-size="64"
                                            data-line-height="50" data-height="20">“</text>
                                        </group>
                                    </group>
                                </div>
                                <div data-space-horizontal="10">
                                    <group className="" data-wrap="no" data-space="20" data-space-vertical="40"
                                        data-radius="10" data-backdrop="" data-justify="center"
                                        data-gap="20">
                                        <group data-opacity="30" data-width="auto" data-align="start"> <text
                                            data-type="group" data-text-size="64" data-line-height="50"
                                            data-height="20">“</text></group>
                                        <group data-direction="column" data-gap="10">
                                            <text data-wrap="wrap" data-text-size="16" data-color="black"
                                                data-weight="700">Eddie
                                                Rosenbaum</text>
                                            <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                data-line="2" data-text-align="justify">
                                                “Lernik’s empathy, resilience, and dedication to promoting healthier
                                                communities, especially for residents in regions affected by crisis,
                                                made a lasting impression.”
                                            </text>
                                        </group>
                                        <group data-opacity="30" data-width="auto" data-align="end"> <text
                                            data-rotate="180" data-type="group" data-text-size="64"
                                            data-line-height="50" data-height="20">“</text>
                                        </group>
                                    </group>
                                </div>
                                <div data-space-horizontal="10">
                                    <group className="" data-wrap="no" data-space="20" data-space-vertical="40"
                                        data-radius="10" data-backdrop="" data-justify="center"
                                        data-gap="20">
                                        <group data-opacity="30" data-width="auto" data-align="start"> <text
                                            data-type="group" data-text-size="64" data-line-height="50"
                                            data-height="20">“</text></group>
                                        <group data-direction="column" data-gap="10">
                                            <text data-wrap="wrap" data-text-size="16" data-color="black"
                                                data-weight="700">Justin
                                                Ramirez </text>
                                            <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                data-line="2" data-text-align="justify">
                                                “ I was going through a rough time related to my work, and I reached
                                                out to Dr. Lernik for holistic strategies to stay healthy. During
                                                our engagements, I loved most that she was attentive and
                                                non-judgmental. I learned small practical tips, such as sleep
                                                hygiene, which tremendously helped with my stress management and
                                                mood boosting.”
                                            </text>
                                        </group>
                                        <group data-opacity="30" data-width="auto" data-align="end"> <text
                                            data-rotate="180" data-type="group" data-text-size="64"
                                            data-line-height="50" data-height="20">“</text>
                                        </group>
                                    </group>
                                </div>
                                <div data-space-horizontal="10">
                                    <group className="" data-wrap="no" data-space="20" data-space-vertical="40"
                                        data-radius="10" data-backdrop="" data-justify="center"
                                        data-gap="20">
                                        <group data-opacity="30" data-width="auto" data-align="start"> <text
                                            data-type="group" data-text-size="64" data-line-height="50"
                                            data-height="20">“</text></group>
                                        <group data-direction="column" data-gap="10">
                                            <text data-wrap="wrap" data-text-size="16" data-color="black"
                                                data-weight="700">Katie
                                                Wilson</text>
                                            <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                data-line="2" data-text-align="justify">
                                                “I have received expert health and wellness advice from Dr. Essayei
                                                on multiple occasions. Every time, I found her approach to be
                                                compassionate, caring, and concerned about my overall well-being.
                                                She is patient and not only met me where I was regarding my needs
                                                and concerns, but also explained her recommendations while
                                                acknowledging my autonomy and decisions in my self-care. Based on
                                                these experiences, Dr. Essayei is a trusted resource for me
                                                regarding various health concerns, and I desire to improve my health
                                                and well-being.”
                                            </text>
                                        </group>
                                        <group data-opacity="30" data-width="auto" data-align="end"> <text
                                            data-rotate="180" data-type="group" data-text-size="64"
                                            data-line-height="50" data-height="20">“</text>
                                        </group>
                                    </group>
                                </div>
                            </Slider>
                        </view>
                    </group>
                    <space data-height="90" data-adaptive="desktop"></space>
                    <space data-height="40" data-adaptive="mobile"></space>
                </group>


            </section>
        </>
    );
};

export default MeetMe;